<template>
  <section></section>
</template>

<script>

import storage from '@/config/storage';

export default {
  mounted(){
    storage.clear('mail4fly--user');
    this.$router.push('/login')
  }
}
</script>
